<table>
  <thead>
    <tr>
      <td>
        <!--place holder for the fixed-position header-->
        <div class="page-header-space"></div>
      </td>
    </tr>
  </thead>

  <tbody>
    <tr>
      <td>
        <!--*** CONTENT GOES HERE ***-->
        <!-- <div class="page-beak-manual">PAGE 1</div>
        <div class="page-beak-manual">PAGE 2</div> -->
        <div class="page-beak-auto" style="line-height: 3">
         <div class="presform">
            <div class="prescription">
               <div class="row" style="border-bottom: 2px solid #d7c4c4">
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 ml-4 mr-4">
                     <!-- <div><img src="assets/images/qrcode.png" alt="" class="" style="width: 215px; height: 85px" /></div> -->
                     <table class="patdatao">
                        <tbody>
                           <tr>
                              <td class="mcdata"><b>UHID </b></td>
                              <td class="mcdata"> : {{ opddata?.uprnNo }}</td>
                           </tr>
                           <tr>
                              <td class="mcdata"><b>OPD Ticket No.</b></td>
                              <td class="mcdata"> : {{ opddata?.pcOPNNO }}</td>
                           </tr>
                           <tr>
                              <td class="mcdata"><b>Department </b></td>
                              <td class="mcdata"> : {{ opddata?.deptName }}</td>
                           </tr>
                           <tr>
                              <td class="mcdata"><b>Patient Type / Patient Sub-Type </b></td>
                              <td class="mcdata"> : {{ opddata?.patientType }} / {{ opddata?.patientSubType }}</td>
                              <!-- <td>{{patientData?.patientSubType == '' ? "NA":patientData?.patientSubType}}</td> -->
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                     <table class="patdatat">
                        <tbody>
                           <tr>
                              <td class="mcdata"><b>Patient Name </b></td>
                              <td class="mcdata"> : {{ opddata?.fullName }}</td>
                           </tr>
                           <tr>
                              <td class="mcdata"><b>Ticket Date and Time  </b></td>
                              <td class="mcdata">
                                 : {{ opddata?.dateOfRegd | date : "dd/MM/yyyy, h:mm a" }}
                              </td>
                           </tr>
                           <tr>
                              <td class="mcdata"><b>Doctor </b></td>
                              <td class="mcdata">: {{ opddata?.doctorname }}</td>
                           </tr>
                           <tr>
                              <td class="mcdata"><b>Gender / Age </b></td>
                              <td class="mcdata"> : {{ opddata?.gender }} / {{ opddata?.Age }}</td>
                           </tr>
                           <tr>
                              <td class="mcdata"><b></b></td>
                              <td class="mcdata"></td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
               </div>
               <div class="row" style="border-bottom: 2px solid #d7c4c4">
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                     <table class="" style="border-right: 2px solid #d7c4c4">
                        <P  class="vbctaddd">Dr's Advice / Investigation & Diagnosis</P>
                        <tbody style="position: relative; bottom: 12px;">
                           <tr style="height: 50px;">
                              <td class="bornone mcdata" style="padding: 0px;"> <b>Initial Observation:</b>  </td>
                              <!-- <td class="mcdata"> {{condata?.initialObservation}}</td> -->
                           </tr>
                           <tr style="height: 50px;">
                              <td class="bornone mcdata" style="padding: 0px;"><b>Clinical Findings:</b> </td>
                              <!-- <td class="mcdata">{{condata?.ClinicalFinding}}</td> -->
                           </tr>
                           <tr style="height: 50px;">
                              <td class="bornone mcdata" style="padding: 0px;"><b>Investigation & Diagnosis: </b></td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                     <table class="">
                        <tbody>
                           <tr style="height: 50px;">
                              <td class="bornone mcdata" style="padding: 0px;"><b>Past History / Family History: </b></td>
                              <!-- <td class="mcdata"> {{condata?.PastHistoryFamilyHistory}}</td> -->
                           </tr>
                           <tr  style="height: 50px;">
                              <td class="bornone mcdata"style="padding: 0px;"><b>Medical / Surgical History / Drug Allergy:</b></td>
                           </tr>
                           <tr style="height: 50px;">
                              <td class="bornone mcdata" style="padding: 0px;"><b>Doctors Advice:</b> </td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  
               </div>
               <div class="row">
                  <!-- <p><strong>R</strong> <sub><b>X</b></sub>:</p> -->
                  <div class="rx-container">R<sub>x </sub><sup></sup></div>
               </div>
               <div class="row">
                  <p
                     style="
                     background-image: url('assets/images/hmch_logo.png');
                     padding: 176px;
                     background-repeat: no-repeat;
                     background-position: center;
                     "
                     ></p>
               </div>
            </div>
            <div class="row m-2" style="border-top: 2px solid #d7c4c4">
             <P  class="vbctaddd" style="margin-top: 10px;">Initial Screening : Vitals</P>
             <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 ml-4 mr-4">
                <table class="patdatao">
               
                   <tbody>
                      <tr>
                         <td class="mcdata"><b>Temperature (°F) </b></td>
                         <td class="mcdata">
                            : {{ inistialscreendata?.temperature }}
                            
                         </td>
                      </tr>
                      <tr>
                         <td class="mcdata"><b>Blood Pressure (mmHg)</b></td>
                         <td class="mcdata">
                            : {{ inistialscreendata?.bloodPressure }}
                         </td>
                      </tr>
                      <tr>
                         <td class="mcdata"><b>Weight (Kg)</b></td>
                         <td class="mcdata"> : {{ inistialscreendata?.weight }}</td>
                      </tr>
                      <tr>
                         <td class="mcdata"><b>Height (cm)</b></td>
                         <td class="mcdata"> : {{ inistialscreendata?.height }}</td>
                      </tr>
                      <tr>
                         <td class="mcdata"><b>Pulse (bpm)</b></td>
                         <td class="mcdata">: {{inistialscreendata?.pulse}} </td>
                      </tr>
                      <tr>
                         <td class="mcdata"><b>Remarks</b></td>
                         <td class="mcdata">: {{inistialscreendata?.remrks}}</td>
                      </tr>
                   </tbody>
                </table>
             </div>
             <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <table class="patdatat">
                
                   <tbody>
                      <tr>
                         <td class="mcdata"><b>RR (per minute)</b></td>
                         <td class="mcdata"> : {{inistialscreendata?.respiratoryRate}} </td>
                      </tr>
                      <tr>
                         <td class="mcdata"><b>SPo2 (in %)</b></td>
                         <td class="mcdata">: {{inistialscreendata?.SPo2}} </td>
                      </tr>
                      <tr>
                         <td class="mcdata">
                            <b> Covid19</b>
                         </td>
                         <td class="mcdata"> : {{ inistialscreendata?.covid19 == "Y" ? "Yes" : inistialscreendata?.covid19 == "D"? "Don't Know": "No" }}
                         </td>
                      </tr>
                      <tr>
                         <td class="mcdata"><b>Any Chronic Disease</b></td>
                         <td class="mcdata">  : {{ inistialscreendata?.anyChronicDisease == "Y" ? "Yes" : inistialscreendata?.anyChronicDisease == "D"
                            ? "Don't Know"
                            : "No"
                            }} <span  *ngIf="inistialscreendata?.anyChronicDisease == 'Y'">({{inistialscreendata?.chronic_diseases}})</span>
                         </td>
                      </tr>
                      <tr>
                         <td class="mcdata"><b>Any Contagious Disease </b></td>
                         <td class="mcdata"> 
                            :  {{ inistialscreendata?.anyContagiousDisease == "Y"  ?  "Yes": inistialscreendata?.anyContagiousDisease == "D"  ? "Don't Know"  : "No"
                            }} <span *ngIf="inistialscreendata?.anyContagiousDisease == 'Y'">({{inistialscreendata?.contagious_diseases}})</span> 
                         </td>
                      </tr>
                   </tbody>
                </table>
             </div>
             <span><b>Screening By : </b>{{inistialscreendata?.ScreeningBy}}({{inistialscreendata?.userName}})</span>
          </div>
         </div>
          
        </div>
      </td>
    </tr>
  </tbody>

  <tfoot>
    <tr>
      <td>
        <!--place holder for the fixed-position footer-->
        <div class="page-footer-space"></div>
      </td>
    </tr>
  </tfoot>
</table>
